import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const NumberFormField = ({ fieldDef, prefix }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled, variant } = useFormFieldDef(fieldDef);

  return (
    <NumericFormat
      // render as MUI TextField
      customInput={TextField}

      // formatting options
      thousandSeparator
      decimalScale={fieldDef.decimalPrecision}
      fixedDecimalScale
      prefix={prefix}
      variant={variant}
      value={value ?? ''}
      onValueChange={(values) => {
        setValue(values.floatValue ?? '');
      }}

      // delegate blur & error/display props
      onBlur={onBlur}
      error={!disabled && error}
      helperText={helperText}
      label={label}
      disabled={disabled}
    />
  );
};